import { render, staticRenderFns } from "./detail-unit.vue?vue&type=template&id=4057b936&lang=pug&"
import script from "./detail-unit.vue?vue&type=script&lang=js&"
export * from "./detail-unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports